var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6926 4.39886C13.0246 4.73081 13.0246 5.269 12.6926 5.60094L7.14366 11.1499H19.0916C19.561 11.1499 19.9416 11.5305 19.9416 11.9999C19.9416 12.4693 19.561 12.8499 19.0916 12.8499H7.14366L12.6926 18.3989C13.0246 18.7308 13.0246 19.269 12.6926 19.6009C12.3607 19.9329 11.8225 19.9329 11.4905 19.6009L4.49054 12.6009C4.15859 12.269 4.15859 11.7308 4.49054 11.3989L11.4905 4.39886C11.8225 4.06692 12.3607 4.06692 12.6926 4.39886Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.a533dd7c617cadbd5f3a06a24fc26731.svg";
export { ForwardRef as ReactComponent };